import { PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_IFA_CLIENT_ID;
const tenantId = process.env.REACT_APP_SLW_DOMAIN;
const authority = `https://login.microsoftonline.com/${tenantId}`;

export const loginRequest = {
  scopes: ['openid', 'profile', 'email']
};

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId:   clientId,
    authority:  authority,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
});

export async function getSwaUser() {
  try {
    const res = await fetch('/.auth/me', { credentials: 'include' });
    if (!res.ok) return null;
    const data = await res.json();
    return data[0]?.clientPrincipal || null;
  } catch (e) {
    console.error("Error fetching SWA user:", e);
    return null;
  }
}
